import script from "./StatusLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusLabel.vue?vue&type=script&setup=true&lang=js"

import "./StatusLabel.vue?vue&type=style&index=0&id=7650f35a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7650f35a"]])

export default __exports__